/* ==========================================================================
   FEBU Product Guide — Jump Nav pin + Scroll Spy
   guide-page.js
   ========================================================================== */
(function() {
  var nav = document.querySelector('.guide-jump-nav');
  var spacer = document.querySelector('.guide-jump-nav-spacer');
  if (!nav) return;

  var scroller = nav.querySelector('.guide-jump-nav__inner');
  var links = nav.querySelectorAll('.guide-jump-nav__link');
  if (!links.length || !scroller) return;

  // --- Horizontal centering of the active link ---
  // Manual scrollLeft math instead of scrollIntoView, which can hijack
  // vertical page scroll and fight the scroll spy.
  function centerLink(link, smooth) {
    if (scroller.scrollWidth <= scroller.clientWidth) return;
    var target = link.offsetLeft - (scroller.clientWidth / 2) + (link.offsetWidth / 2);
    var max = scroller.scrollWidth - scroller.clientWidth;
    target = Math.max(0, Math.min(target, max));
    scroller.scrollTo({ left: target, behavior: smooth === false ? 'auto' : 'smooth' });
  }

  // --- Edge fade affordance: shows which direction has more content ---
  function updateEdgeFades() {
    if (scroller.scrollWidth <= scroller.clientWidth + 2) {
      nav.classList.remove('has-overflow-left', 'has-overflow-right');
      return;
    }
    var atStart = scroller.scrollLeft <= 2;
    var atEnd = scroller.scrollLeft >= (scroller.scrollWidth - scroller.clientWidth - 2);
    nav.classList.toggle('has-overflow-left', !atStart);
    nav.classList.toggle('has-overflow-right', !atEnd);
  }

  scroller.addEventListener('scroll', updateEdgeFades, { passive: true });
  window.addEventListener('resize', updateEdgeFades);
  window.setTimeout(updateEdgeFades, 60);

  // --- Center on tap so the reader sees the nav move ---
  links.forEach(function(link) {
    link.addEventListener('click', function() {
      centerLink(link);
    });
  });

  // --- One-time nudge on load: signals the nav is scrollable ---
  window.setTimeout(function() {
    if (scroller.scrollWidth <= scroller.clientWidth) return;
    if (scroller.scrollLeft > 0) return;
    scroller.scrollTo({ left: 28, behavior: 'smooth' });
    window.setTimeout(function() {
      scroller.scrollTo({ left: 0, behavior: 'smooth' });
    }, 420);
  }, 700);

  // --- Pin / unpin behavior (replaces sticky which fails across sections) ---
  var navOriginalTop = null;
  var navHeight = 0;

  function measureNav() {
    // Capture nav's natural position in the document
    var wasPinned = nav.classList.contains('is-pinned');
    if (wasPinned) {
      nav.classList.remove('is-pinned');
      if (spacer) spacer.classList.remove('is-active');
    }
    var rect = nav.getBoundingClientRect();
    navOriginalTop = rect.top + window.pageYOffset;
    navHeight = rect.height;
    if (spacer) spacer.style.height = navHeight + 'px';
    if (wasPinned) {
      nav.classList.add('is-pinned');
      if (spacer) spacer.classList.add('is-active');
    }
  }

  function handleScroll() {
    if (navOriginalTop === null) return;
    var shouldPin = window.pageYOffset >= navOriginalTop;
    var isPinned = nav.classList.contains('is-pinned');
    if (shouldPin && !isPinned) {
      nav.classList.add('is-pinned');
      if (spacer) spacer.classList.add('is-active');
    } else if (!shouldPin && isPinned) {
      nav.classList.remove('is-pinned');
      if (spacer) spacer.classList.remove('is-active');
    }
  }

  // Throttle scroll handler with rAF
  var scrollTicking = false;
  function onScroll() {
    if (!scrollTicking) {
      window.requestAnimationFrame(function() {
        handleScroll();
        scrollTicking = false;
      });
      scrollTicking = true;
    }
  }

  // Initial measurement after a tick (to let layout settle)
  window.setTimeout(measureNav, 50);
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', measureNav);
  // Re-measure after images load (heights can shift)
  window.addEventListener('load', measureNav);

  // --- Scroll spy (active link highlighting) ---
  var sectionIds = [];
  var linkMap = {};
  links.forEach(function(link) {
    var id = link.getAttribute('href').replace('#', '');
    sectionIds.push(id);
    linkMap[id] = link;
  });

  var currentActive = null;
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        var id = entry.target.id;
        if (currentActive) currentActive.classList.remove('is-active');
        if (linkMap[id]) {
          linkMap[id].classList.add('is-active');
          currentActive = linkMap[id];
          centerLink(linkMap[id]);
        }
      }
    });
  }, {
    rootMargin: '-80px 0px -60% 0px',
    threshold: 0
  });

  sectionIds.forEach(function(id) {
    var el = document.getElementById(id);
    if (el) observer.observe(el);
  });
})();